
import {
    defineComponent, ref, reactive, inject 
} from 'vue'

import type {
    FormInstance,
    FormRules,
    UploadInstance,
    UploadProps,
    UploadRawFile
} from "element-plus";

import JwtService from "@/core/services/JwtService";
import personService from "@/core/services/PersonService"
import SanctionService from "@/core/services/SanctionService"
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    props: {
        idperson: {
            type: String,
            required: true,
            default: ""
        },
        item: {
            type: Object,
            required: false,
            default: {}
        }
    },
    setup(props,{emit}) {
        const titleDialog = ref('')
        const gblDialog = inject<any>('gblDialog')
        const gblAction = inject<any>('gblAction')
        const listEvents = ref([])

        //form
        const ruleFormRef = ref < FormInstance > ()
        const form = reactive({
            idsanction: null,
            idacreditation: '',
            idperson: '',
            num_resolution: '',
            startdate: '',
            endate:'',
            message: '',
            mstatus: ''
        })

        //loaders
        //const loaderSearch = ref(false)
        const loaderForm = ref(false)
        //upload
        const upload = ref < UploadInstance > ()
        const urlUpload = ref(process.env.VUE_APP_API_URL)
        const rules = reactive < FormRules > ({
            idacreditation: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            num_resolution: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            startdate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            endate:[{
                type: 'date',
                required: true,
                message: 'Seleccione una fecha',
                trigger: ["blur","change"]
            }],
            message: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            mstatus: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const onOpen = () => {
            titleDialog.value = gblAction.value == 'new' ? 'Registrar sanción' : 'Editar Sanción'
        }

        const onOpened = () => {
            getHistory()
            if(gblAction.value == 'edit')
                Object.assign(form, props.item)
        }

        const onClosed = () => {
            titleDialog.value = ''
            resetForm(ruleFormRef.value)
        }

        const getHistory = () => {
            loaderForm.value = true
            listEvents.value.length = 0
            personService.getHistorial(props.idperson)
                .then((res) => {
                    listEvents.value = res.data
                    loaderForm.value = false
                }).catch(({ response }) => {
                    loaderForm.value = false
                    errManager(response)
            })
        }
        /*const remoteSearch = async (query: string) => {
            if (query) {   
                loaderSearch.value = true
                await eventService.getDetails(`${query}?type=name&list=true`)
                    .then( (res) => {
                        loaderSearch.value = false
                        listEvents.value = res.data
                    }).catch( ({ response }) => {
                        loaderSearch.value = false
                        errManager(response)
                    })
            } else {
                listEvents.value = []
            }
        }*/

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    (gblAction.value == 'new') ? save() : update()
                  
            });
        };

        const save = () => {
            loaderForm.value = true
            form.idperson = props.idperson
            SanctionService.save(form)
            .then( (res) => {
                loaderForm.value = false
                emit("response", res.data)
            }).catch( ({response}) => {
                loaderForm.value = false
                errManager(response)
            })
        }

        const update = () => {
            loaderForm.value = true
            form.idperson = props.idperson
            SanctionService.update(form.idsanction, form)
            .then( (res) => {
                loaderForm.value = false
                emit("response", res.data)
            }).catch( ({response}) => {
                loaderForm.value = false
                errManager(response)
            })
        }

        return {
            gblDialog,
            gblAction,
            titleDialog,
            listEvents,
            ruleFormRef,
            upload,
            urlUpload,
            form,
            rules,
            loaderForm,

            //events,
            getHistory,
            onOpen,
            onOpened,
            onClosed,
            resetForm,
            submitForm
        }
    },
})
